import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "theme"
  static values = { theme: String }

  connect() {
    super.connect()
    this.applyTheme()
  }

  themeValueChanged() {
    this.applyTheme()
  }

  applyTheme() {
    const theme = this.themeValue
    if (!theme) return

    const dataTheme = this.resolveDataTheme(theme)
    document.documentElement.setAttribute("data-theme", dataTheme)

    this.send("themeChanged", { theme }, () => {})
  }

  resolveDataTheme(theme) {
    if (theme === "dark") return "floosyo-dark"
    if (theme === "light") return "floosyo"

    const isDark = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
    return isDark ? "floosyo-dark" : "floosyo"
  }
}
